<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="cp gray400 mr-4" @click="changeScreen('back')" />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">Select a Category</h4>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="font-black ml-auto cp font20" @click="hide" />
    </div>
    <div
      class="cp mb-2 p-3 rounded fw700 font14"
      v-for="category in typesOfCategories"
      :key="category.name"
      @click="changeScreen('add', 'category', category.name)"
      :style="{
        background: category.name === selectedCategory ? getPrimaryColor() : '#F8FAFD',
        color: category.name === selectedCategory ? '#FFFFFF' : '##647490',
      }"
    >
      {{ category.name }}
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const QARepository = RepositoryFactory.get("qa")

export default {
  name: "CategoriesScreen",
  props: { changeScreen: Function, selectedCategory: String, hide: Function },
  created() {
    QARepository.getQuestionCategories()
      .then(res => {
        let isOthers = null
        this.categories = res.data.data.filter((ele, index) => {
          if (ele.display_name === "Other") {
            isOthers = ele
          }
          return ele.display_name !== "Other"
        })
        this.categories.push(isOthers)
      })
      .catch(err => null)
  },
  data() {
    return {
      typesOfCategories: [{ name: "General" }, { name: "Activity" }, { name: "Symptoms" }, { name: "Treatment" }, { name: "Side Effects" }],
      categories: [],
    }
  },
}
</script>

<style lang="scss" scoped>
.rounded {
  &:hover {
    background: #cbd5e1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Categories.vue